<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Sorteren | Odd-one-out" [steps]="questions().length" [progress]="progress()" />

  <rid-mechanic-content>
    <!-- title -->
    @for (input of [question().question]; track input) {
      <rid-mechanic-title [title]="input" [animate.enter]="index() > 0 ? 'wait-500' : undefined" />
    }

    <!-- options -->
    @for (input of [question()]; track input.id) {
      <div class="absolute grid grid-cols-2 gap-4" animate.leave="anim-fade-out">
        @for (option of question().options; track $index) {
          <div animate.enter="anim-pop-in" [style.animation-delay.ms]="250 + $index * 100">
            <rid-content-card
              [text]="option"
              [isClickable]="!isChecking()"
              [isClicked]="chosen() === $index"
              [state]="chosen() === $index ? (question().answer === $index ? 'CORRECT' : 'INCORRECT') : 'DEFAULT'"
              (clicked)="choose($index)"
            />
          </div>
        }
      </div>
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
